export default __webpack_public_path__ + "static/GothamNarrowBold-3f7d210198f36f58b6bc960db53befb4.otf";